export default function isValidColor(color) {
    return color && /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(color);
}



// WEBPACK FOOTER //
// ./src/helpers/isValidColor.js